import { useCustomEventListener } from 'helpers/events';
import { navigationHubEvent } from 'helpers/navigation';
import { useNavigation } from 'hooks/navigation';

export function NavigationHub() {
	const { routes, navigate, replace } = useNavigation();

	useCustomEventListener(
		navigationHubEvent,
		{
			onListen: payload => {
				if (payload.navigate) return navigate(payload.navigate({ routes }));
				if (payload.replace) return replace(payload.replace({ routes }));
			}
		},
		[]
	);

	return null;
}
